<template>
  <div class="container">
    <app-header title="订单详情" :is-back="isBack" @back="back"/>
    <div class="header2">
      <template v-if="data.isBack===0">
        <div class="state" v-if="data.orderStatus == 0">待发货</div>
        <div class="state" v-if="data.orderStatus == 2">待支付</div>
        <div class="state" v-if="data.orderStatus == 4">卖家已发货</div>
        <div class="state" v-if="data.orderStatus == 5">已完成</div>
      </template>
      <template v-if="data.isBack===1">
        <div class="state" v-if="data.backStatus===0">退款中</div>
        <div class="state" v-if="data.backStatus===1">退款成功</div>
        <div class="hint" v-if="data.backStatus===2">退款失败</div>
      </template>

      <div class="headerDate">{{data.createTime}}</div>
    </div>
    <div class="content" v-for="(item,index) in data.orderItemList" :key="index"  @click.stop="onNavigate(item.shopProduct.id)">
      <img :src="item.shopProduct.image " width="98px" height="110px"/>
      <div class="messages">
        <div class="title">{{item.name}}</div>
        <div class="price">￥{{item.totalPrice}}</div>
        <div class="mehint">已选:{{item.description}}</div>
      </div>
    </div>
    <div class="alltui" @click="refund" v-if="data.isBack===0">
      <div class="tui" v-if="data.orderStatus == 0 || data.orderStatus == 4">退款</div>
      <div class="tui" v-if="data.orderStatus == 5">申请售后</div>
    </div>
    <div class="total">
      <div class="totaltext">商品总价</div>
      <div class="price">
        <span style="color: #999999">￥</span>
        <span>{{data.productPrice}}</span>
      </div>
    </div>
    <div v-show="show">
      <div class="total">
        <div class="totaltext">运费</div>
        <div class="price">
          <span style="color: #999999">￥</span>
          <span>{{data.shippingAmount}}</span>
        </div>
      </div>
      <div class="total">
        <div class="totaltext">返利金额抵扣</div>
        <div class="price">
          <span style="color: #999999">-￥</span>
          <span>{{data.incomePrice}}</span>
        </div>
      </div>
      <div class="total">
        <div class="totaltext">优惠券抵扣</div>
        <div class="price">
          <span style="color: #999999">-￥</span>
          <span>{{data.couponPrice}}</span>
        </div>
      </div>
    </div>
    <div class="total" style="margin-bottom: 10px">
      <div class="totaltext">实付款</div>
      <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
        <div class="allprice">￥{{data.totalPrice}}</div>
        <img src="@/assets/up.png" alt="" width="13" height="13" @click="show = false" v-if="show">
        <img src="@/assets/down.png" alt=""  width="13" height="13" @click="show = true" v-if="!show">
      </div>
    </div>
    <div class="orderde">
      <div class="orderTitle">订单信息</div>
      <div class="codedeta">
        <div class="code">订单编号：<span>{{data.orderNo}}</span></div>
        <div class="copy" @click="doCopy(data.orderNo)">复制</div>
      </div>
      <div class="be" v-if="data.remark">订单备注：<span class="juli">{{data.remark}}</span></div>
      <div class="be">创建时间：<span class="juli">{{data.createTime}}</span></div>
      <!-- 除等待商家发货状态以外显示 -->
      <div v-if="data.orderStatus == 5 || data.orderStatus == 4 || data.orderStatus == 0">
        <div class="be">付款时间：<span class="juli">{{data.createTime}}</span></div>
        <div class="be" v-if="data.orderStatus == 4 || data.orderStatus == 5">发货时间：<span class="juli">{{data.updateTime}}</span></div>
        <div class="be" v-if="data.orderStatus == 4 || data.orderStatus == 5">配送方式：<span class="juli">{{$enums.FreightType[data.freightType]}}</span></div>
        <div class="be">发票：<span class="juli">{{$enums.IssueType[data.isIssue]}}</span></div>
        <div class="be" style="margin-bottom: 14px">支付方式：
          <span class="juli" v-if="data.isOnlinepay==0 && data.payType==0">余额支付</span>
          <span class="juli" v-if="data.isOnlinepay==0 && data.payType==1">微信支付</span>
          <span class="juli" v-if="data.isOnlinepay==1">线下支付</span>
        </div>
      </div>
      <div class="be">
        收货地址：
        <span class="juli">{{data.address + data.detail}}</span>
      </div>
      <div class="be">
        收货人：
        <span class="juli">{{data.receiver}}</span>
      </div>

      <!-- 等待商家发货 -->
      <div v-if="fahuo==false" class="hintGoods">
        <div class="hintde">提醒发货</div>
      </div>
    </div>

    <!--  等待卖家发货和卖 -->
    <van-tabbar class="deliver" v-if="data.orderStatus == 0 && data.isBack == 0" style="justify-content: flex-end;padding: 0 12px;box-sizing: border-box">
      <div class="deliverBorder" style="border:1px solid rgba(254,0,59,1);"  @click="$toast.success('提醒成功')">
        <div class="select" style="color:rgba(254,0,59,1);">提醒发货</div>
      </div>
      <!--<div class="record" style="margin-left: 10%">-->
        <!--<img src="@/assets/alibaba.png" width="18" height="18"/>-->
        <!--<div class="reco">联系卖家</div>-->
      <!--</div>-->
      <!--<div class="record" style="margin-right: 10%">-->
        <!--<img src="@/assets/daPhone.png" width="18" height="18"/>-->
        <!--<div class="reco">拨打电话</div>-->
      <!--</div>-->
    </van-tabbar>

    <!-- 卖家已经发货 -->
    <van-tabbar class="deliver" v-if="data.orderStatus == 4 || data.orderStatus == 5">
      <div class="deliverBorder" style="border: 1px solid #666666;" @click="examine"  v-if="data.orderStatus == 4 || data.orderStatus == 5">
        <div class="select" style="color: #666666">查看物流</div>
      </div>
      <div class="deliverBorder" style="border:1px solid rgba(254,0,59,1);" @click="confirmReceipt"  v-if="data.orderStatus == 4">
        <div class="select" style="color:rgba(254,0,59,1);">确认收货</div>
      </div>
    </van-tabbar>
  </div>
</template>

<script>
    import { getOrderDetail, getOrderAndProduct, deleteShopOrder, wxPayServiceFee, queryorder, confirmReceipt } from '@/api/order'
    export default {
        name: "detail",
        data(){
            return{
              isBack: false,
              orderStatus: 0,
              data : {},
              show: true,      // 价格显示隐藏
              base:true,       // 底部导航栏根据物流状态显示不同的内容
              fahuo:true,    // 卖家是否发货，未发货提示发货
            }
        },
        created() {
          this.getDetailInfo()
          this.orderStatus = this.$route.query.orderStatus
        },
        methods:{
          back(){
            this.$route.params.orderStatus = this.orderStatus
            this.$router.go(-1)
          },
          doCopy(val) {
            let that = this
            that.$copyText(val).then(function (e) {
              that.$toast("复制成功！")
            }, function (e) {
              that.$toast("复制失败！")
            })
          },
          getDetailInfo() {
            var user = localStorage.getItem('userInfo')
            if (!user){
              this.$router.push({path: '/login'})
              return;
            }
            user = JSON.parse(user)
            getOrderDetail({ uid: user.id, id : this.$route.query.orderId}).then(res => {
              if (res.success) {
                this.data = res.data

              }
            })
          },
          confirmReceipt(){
            confirmReceipt({id : this.$route.query.orderId}).then(res => {
              if (res.success) {
                this.$toast.success('收货成功')
                this.back()
              }
            })
          },
          onNavigate(id) {
            this.$router.push({
              path: '/product/detail',
              query: {id: id}
            })
          },
          examine(){
            if (this.data.shippingType==0){
              this.$router.push({
                path: '/order/logistics',
                query:{
                  orderId : this.$route.query.orderId
                }
              })
            }
            if (this.data.shippingType==1){
              this.$router.push({
                path: '/order/logisticsRenGon',
                query:{
                  orderId : this.$route.query.orderId
                }
              })
            }

          },
          refund() {
            this.$router.push({
              path:'/refund',
              query:{
                orderId : this.$route.query.orderId,
                total : this.data.totalPrice
              }
            })
          }
        }
    }
</script>

<style lang="less" scoped>
  .container{
    .header2{
      width:100%;
      height:114px;
      background:rgba(254,0,59,1);
      opacity:1;
      .state{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:25px;
        color:rgba(255,255,255,1);
        opacity:1;
        margin-left: 12px;
        padding-top: 16px;
      }
      .headerDate{
        margin-left: 12px;
        margin-top: 20px;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:22px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
    }
    .content{
      display: flex;
      flex-direction: row;
      padding: 12px;
      .messages{
        width: 100%;
        margin-left: 10%;
        .title{
          /*height:47px;*/
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:18px;
          color:rgba(51,51,51,1);
          opacity:1;
          overflow: hidden;
          word-wrap: break-word;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp:2;
          flex: 1;
        }
        .price{
          height:47px;
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:18px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .mehint{
          height:18px;
          font-size:12px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:17px;
          color:rgba(136,137,136,1);
          background:rgba(243,243,243,1);
          border-radius:1px;
          opacity:1;
        }
      }
    }
    .alltui{
      margin-left: 70%;
      margin-top: 10px;
      margin-bottom: 29px;
      .tui{
        width:84px;
        height:28px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(233,232,232,1);
        opacity:1;
        border-radius:14px;
        font-size:14px;
        font-family:PingFang SC;
        text-align: center;
        font-weight:400;
        line-height:28px;
        color:rgba(102,102,102,1);
      }
    }
    .total{
      display: flex;
      padding-left: 12px;
      padding-right: 12px;
      padding-bottom: 5px;
      justify-content: space-between;
      .totaltext{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .price{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .allprice{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(254,0,59,1);
      }
    }
    .hintGoods{
      width:84px;
      height:28px;
      background:rgba(255,255,255,1);
      opacity:1;
      border-radius:14px;
      text-align: center;
      margin-top: 12px;
      border:1px solid rgba(254,0,59,1);
      margin-bottom: 14px;
      margin-left: 70%;
      .hintde{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:28px;
        opacity:1;
        color:rgba(254,0,59,1);
      }
    }
    .orderde{
      border-top: 2px solid #EDEDED;
      border-bottom: 2px solid #EDEDED;
      margin-bottom: 145px;
      padding-bottom: 10px;
      .orderTitle{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
        padding: 12px;
      }
      .codedeta{
        display: flex;
        justify-content: space-between;
        margin-right: 12px;
        margin-left: 12px;
        margin-bottom: 7px;
        .code{
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:18px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .copy{
          font-size:13px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:18px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .be{
        font-size:13px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:18px;
        margin-left: 12px;
        margin-top: 7px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
    }
    .active_tab{
      display: flex;
      justify-content: space-between;
      .record{
        display: flex;
        text-align: center;
        line-height: 50px;
        padding: 15px;
        .recordtitle{
          font-size:16px;
          font-family:PingFang SC;
          font-weight:500;
          line-height:22px;
          opacity:1;
        }
        .reco{
          font-size:16px;
          font-family:PingFang SC;
          font-weight:500;
          line-height:22px;
          opacity:1;
          margin-left: 10px;
        }
      }
    }
    .deliver{
      display: flex;
      justify-content: flex-end;
      .deliverBorder{
        width:84px;
        height:28px;
        background:rgba(255,255,255,1);
        opacity:1;
        border-radius:14px;
        text-align: center;
        margin-top: 12px;
        margin-right: 20px;
      }
      .select{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:28px;
        opacity:1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/order/details.vue